// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/checbox-icon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/images/file-download.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/images/user-menu-icon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml;base64,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", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%28218, 13, 41, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%28255, 255, 255, 1%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `table.flotas td {
  font-weight: 700;
  vertical-align: middle;
}

.flotas-btn button img {
  opacity: 0.7;
  transition: all 0.2s linear;
}

.flotas-btn button img:hover,
.flotas-btn button img:active {
  opacity: 1;
  transition: all 0.2s linear;
}

.flotas-table-select {
  display: inline;
  vertical-align: super;
}

.flotas-table-select > input[type="checkbox"] {
  padding: 0.5em;
  margin: 0em 2em;
  cursor: pointer;
}

.flotas-table-select > input[type="checkbox"]:checked::after,
.flotas-table-select > .form-check-input:checked[type="checkbox"] {
  color: #db0b27;
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 60% 60%; /* Adjust as needed */
  background-color: #fff;
}

.flotas-table .dropdown-toggle::after,
.flotas-saldo .dropdown-toggle::after {
  content: "" !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) !important;
  background-size: 1em;
  background-repeat: no-repeat;
  background-position: center;
  width: 1.2em;
  height: 1.2em;
  margin-left: 0.5em;
  font-size: 0.8em;
  animation: rotate-up 0.3s ease-in-out;
  transform: scaleY(1);
  display: inline-block;
  vertical-align: middle;
  position: absolute;
  right: 1em;
  top: 2.2em;
}

.flotas-btn-add {
  font-size: 0.9em;
}

.flotas-selection {
  display: block;
  width: 100%;
}

.flotas-selection-div {
  display: inline-block;
  width: -moz-fit-content;
  width: fit-content;
  padding: 1.3em 1em;
  border-radius: 0.375rem;
  background-color: #ececec;
  border: none;
  color: #2b363b;
  font-weight: 700;
  margin-right: 0.48em;
  cursor: not-allowed;
  text-transform: capitalize;
}

.flotas-selection .dropdown-toggle,
.flotas-saldo .dropdown-toggle {
  background-color: #ececec;
  border: none;
  color: #2b363b;
  font-weight: 700;
  padding-bottom: 0.9em;
  padding-top: 0.9em;
  text-transform: capitalize;
  width: 100%;
  text-align: left;
}

.flotas-selection .dropdown-toggle::after,
.flotas-saldo .dropdown-toggle::after {
  content: "" !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) !important;
  background-size: 1em;
  background-repeat: no-repeat;
  background-position: center;
  width: 1.2em;
  height: 1.2em;
  margin-left: 0.5em;
  font-size: 0.8em;
  animation: rotate-up 0.3s ease-in-out;
  transform: scaleY(1);
  display: inline-block;
  vertical-align: middle;
  position: absolute;
  right: 1em;
  top: 2.2em;
}

.flotas-selection .dropdown-toggle.show::after,
.flotas-saldo .dropdown-toggle.show::after {
  transform: scaleY(-1);
  animation: rotate-down 0.3s ease-in-out;
}

@keyframes rotate-down {
  0% {
    transform: scaleY(1);
  }
  100% {
    transform: scaleY(-1);
  }
}

@keyframes rotate-up {
  0% {
    transform: scaleY(-1);
  }
  100% {
    transform: scaleY(1);
  }
}

.flotas-selection .dropdown-toggle::before,
.flotas-saldo .dropdown-toggle::before {
  content: "";
  font-size: 1.3em;
  margin-right: 0.2em;
}

.flotas-selection .dropdown-toggle::before,
.flotas-selection-div::before {
  content: "" !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-size: 1.4em;
  background-repeat: no-repeat;
  background-position: center;
  width: 2em;
  height: 2em;
  display: inline-block;
  vertical-align: middle;
}

.flotas-selection.show > .btn-primary.dropdown-toggle,
.flotas-saldo.show > .btn-primary.dropdown-toggle,
.btn-primary.dropdown-toggle:active:focus {
  background-color: #ececec;
  border: none;
  color: #2b363b;
  box-shadow: none;
}

.flotas-saldo.show > .btn-primary.dropdown-toggle:focus {
  box-shadow: none;
}

.flotas-actions {
  margin-top: 0em;
}

.flotas-actions .dropdown {
  /* margin-right: 0; */
  width: -moz-fit-content;
  width: fit-content;
}

.flotas-selection-item {
  text-transform: capitalize;
}

.flotas-buttons {
  display: flex;
  flex-direction: row-reverse;
}

.flotas-buttons .btn-check:checked + .btn-outline-danger {
  background-color: #db0b27;
  border-color: #db0b27;
  transition: all 0.3s 0.1s ease-in-out;
}

.flotas-btn-km label {
  border-radius: 3em;
  font-size: 0.7em;
  font-weight: 700;
  line-height: 1em;
  max-width: 5em;
}

.flotas-btn-km.btn-group > .btn:nth-child(n + 3),
.flotas-btn-km.btn-group > :not(.btn-check) + .btn,
.flotas-btn-km.btn-group > .btn-group:not(:first-child) > .btn,
.flotas-btn-km.btn-group > .btn:not(:last-child):not(.dropdown-toggle),
.flotas-btn-km.btn-group > .btn-group:not(:last-child) > .btn {
  border: none;
  border-radius: 3em;
}

.flotas-btn-km.btn-group {
  background-color: #ececec;
  border-radius: 3em;
  transition: all 0.3s 0.1s ease-in-out;
}

.btn-check:checked + .btn-outline-danger:focus {
  box-shadow: none;
}

#notifications-icon-check img.flotas-btn-notification-white {
  filter: invert(42%) saturate(2%) brightness(200%) contrast(200%);
}

.alert-danger-form {
  color: #db0b27;
  background-color: #f2dede;
  border-color: #ebccd1;
  font-size: 0.9em;
}

.flotas-btn-error {
  border: #db0b27;
  border-width: 3px;
  border-style: solid;
}

.filter-primary {
  filter: brightness(0) saturate(100%) invert(13%) sepia(98%) saturate(4979%)
    hue-rotate(346deg) brightness(87%) contrast(100%);
}

.alert-promocion {
  background-color: #8bf1b6;
  border-color: #8bf1b6;
  min-width: -moz-fit-content;
  min-width: fit-content;
  padding: 1em;
  text-align: center;
  width: 80%;
}

.alert-incidencia {
  color: #842029;
  background-color: #f8d7da;
  border-color: #f5c2c7;
  min-width: -moz-fit-content;
  min-width: fit-content;
  padding: 1em;
  text-align: center;
  width: 80%;
}

.alert-repostaje {
  color: #055160;
  background-color: #cff4fc;
  border-color: #b6effb;
  min-width: -moz-fit-content;
  min-width: fit-content;
  padding: 1em;
  text-align: center;
  width: 80%;
}

.alert-credito {
  color: #084298;
  background-color: #cfe2ff;
  border-color: #b6d4fe;
  min-width: -moz-fit-content;
  min-width: fit-content;
  padding: 1em;
  text-align: center;
  width: 80%;
}

.alert-antifraude {
  color: #664d03;
  background-color: #fff3cd;
  border-color: #ffecb5;
  min-width: -moz-fit-content;
  min-width: fit-content;
  padding: 1em;
  text-align: center;
  width: 80%;
}

.flotas-selection > .dropdown-menu {
  background-color: #ececec;
  border: none;
  text-align: left;
  width: 100%;
  top: 90% !important;
}

.flotas-selection > .dropdown-menu a {
  font-weight: 700;
  padding-bottom: 0.5em;
  padding-top: 0.5em;
  overflow: hidden;
  text-overflow: ellipsis;
}

.no-flota {
  text-align: center;
}

.no-flota h2 {
  margin-top: 5vh;
}

#buscadorFlotas::placeholder {
  color: #2b363b80;
  font-weight: 600;
}

#switch-km {
  border-radius: 2em;
  font-size: 1em;
}

#switch-km:hover {
  cursor: pointer;
}

.form-switch .form-check-input:focus {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}

.form-switch .form-check-input:checked {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}

.flotas-registro-nueva .btn-flota-registro-tipo.btn-lg {
  background-color: #ececec;
  border: none;
  border-radius: 17px;
  box-shadow: 3px 4px 10px rgb(0 0 0 / 30%);
  color: #2b363b;
  font-size: 1.6em;
  font-weight: 700;
  margin-bottom: 2vh;
  padding: 2.5em 2em;
  width: 100%;
}

h1.flotas-registro {
  font-size: 1.4em;
  font-weight: 700;
}

h1.flotas-registro.centered {
  text-align: center;
}

.btn-primary:disabled,
.btn-primary.disabled {
  background-color: transparent;
  border-color: #2b363b40;
  color: #2b363b40;
}

.flotas-registro-buttons {
  display: inline-flex;
  justify-content: space-between;
}

.flotas-registro-buttons button {
  margin: 0 0.3em;
  width: inherit;
}

input.flotas-input {
  font-size: 1.7em;
  font-weight: 700;
  min-height: 2em;
  padding: 0;
  text-align: center;
}

input.flotas-input:focus {
  background-color: #ececec;
  min-height: 2em;
  padding: 0;
}

p.flotas-registro-moneda {
  font-size: 1.4em;
  margin-top: 1.4em;
  text-align: center;
}

.flotas-pref-tel > .dropdown-toggle::after {
  content: "" !important;
  font-size: 1em;
  transform: rotate(180deg);
}

.btn-flotas-tel {
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  line-height: 1.25;
  padding: 1rem 0.75rem;
}

.flotas-pref-tel.flotas-pref-tel-ES > .dropdown-toggle::before {
  background-image: url(https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/4.1.4/flags/4x3/es.svg);
  background-size: 1.5em 1.5em;
  display: inline-block;
  background-repeat: no-repeat;
  width: 2em;
  height: 1.5em;
  content: "";
  vertical-align: bottom;
}

.flotas-pref-tel.flotas-pref-tel-PT > .dropdown-toggle::before {
  background-image: url(https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/4.1.4/flags/4x3/pt.svg);
  background-size: 1.5em 1.5em;
  display: inline-block;
  background-repeat: no-repeat;
  width: 2em;
  height: 1.5em;
  content: "";
  vertical-align: bottom;
}

.flotas-pref-tel.flotas-pref-tel-AR > .dropdown-toggle::before {
  background-image: url(https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/4.1.4/flags/4x3/ar.svg);
  background-size: 1.5em 1.5em;
  display: inline-block;
  background-repeat: no-repeat;
  width: 2em;
  height: 1.5em;
  content: "";
  vertical-align: bottom;
}

.flotas-pref-tel.flotas-pref-tel-MX > .dropdown-toggle::before {
  background-image: url(https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/4.1.4/flags/4x3/mx.svg);
  background-size: 1.5em 1.5em;
  display: inline-block;
  background-repeat: no-repeat;
  width: 2em;
  height: 1.5em;
  content: "";
  vertical-align: bottom;
}

.flotas-pref-tel > .dropdown-menu.show {
  border: 2px solid #f5c2c7;
  border-radius: 0.8em;
  margin-bottom: 0.7em;
  padding: 1em;
  width: 14em;
}

.flotas-pref-tel > .dropdown-menu.show > a {
  font-size: 1.1em;
  font-weight: 600;
  padding: 0.4em 1.5em 0.4em 0.3em;
}

.flotas-pref-tel > .dropdown-menu.show > a > img {
  height: 1.8em !important;
  margin-right: 1em;
  width: 1.8em !important;
}

.back-btn-tarjeta {
  margin-left: 10%;
  width: 83%;
}

.flotas-warning-icon,
.flotas-pdf-icon,
.flotas-study-icon {
  border-radius: 10px;
  display: block;
  height: 80px;
  padding: 1.5em 1em;
  text-align: center;
  width: 80px;
}

.flotas-warning-icon {
  background-color: #ececec;
}

.flotas-pdf-icon {
  background-color: #db0b27;
}

.flotas-study-icon {
  padding: 0.5em;
}

.flotas-model-download {
  align-items: center;
  display: flex;
}

.flotas-model-download p {
  margin-left: 0.8em;
}

.flotas-status-process {
  color: #ffc107;
  font-weight: 700;
}

.flotas-status {
  align-items: center;
  display: flex;
}

.flotas-status img {
  max-width: 60px;
}

p.flotas-study {
  max-width: 75%;
  text-align: left;
}

#upload-document {
  opacity: 0;
  position: absolute;
  width: 20%;
  z-index: -1;
}

.flotas-document-btn {
  display: flex;
  justify-content: space-evenly;
}

.modal-80w {
  max-width: 80vw;
}

.row-no-padding {
  padding: 0;
  margin-left: 0;
}

.flotas-info-tipo-cuenta {
  font-size: 1.2em !important;
  font-weight: 900 !important;
  display: block;
  text-transform: capitalize;
}

.flotas-info-tags {
  display: flex;
  overflow-x: scroll;
  width: max-content;
}

.flotas-info-tags > .alert.alert-danger {
  text-align: left;
  max-width: 15em;
  min-width: 8.2em;
  padding: 0.3em 2em 0.3em 1em;
  background-color: #ececec;
  border: none;
  color: #2b363b;
  margin-right: 0.6em;
  max-height: 4.1em;
  margin-bottom: 0;
}

.flotas-info-tag-title {
  display: block;
  font-size: 1em !important;
  font-weight: 700 !important;
  margin-bottom: -0.5em;
  color: #2b363bbf;
}

.flotas-info-tag-number {
  font-size: 1.3em !important;
  font-weight: 900 !important;
}

.flota-bloqueada {
  max-width: 35em;
  text-align: left;
  display: inline-flex;
  vertical-align: middle;
  font-weight: 700;
  font-size: 0.8em;
  background: #da0d2926;
  padding: 0.6em 1em;
  border-radius: 0.5em;
  color: #da0d29;
  margin-top: 1em;
}

.flota-bloqueada-icon {
  margin-right: 2em;
  width: 30px;
  height: 31px;
}

.thin {
  font-weight: 300 !important;
}

.btn-icon-font {
  color: #606676;
}

.btn-icon-font:hover {
  color: #1d253c;
}

.flotas-actions-btn-trash {
  font-size: 0.9em;
}

.btn-outline-grey .flotas-actions-btn-trash{
background-color: transparent;
  border-color: #2b363b40;
  color: #2b363b40;
}

/* BREAKPOINT TABLETS*/
@media (min-width: 768px) {
}

/* BREAKPOINT ESCRITORIO */
@media (min-width: 992px) {
  /* General Styles */
  .flotas-register-btn {
    width: -moz-fit-content;
    width: fit-content;
    margin: 0 auto;
    padding-left: 2em;
    padding-right: 2em;
  }

  .flotas-btn-step1 {
    display: flex;
  }

  .flotas-registro-nueva .btn-flota-registro-tipo.btn-lg {
    margin: 0 0.5em;
  }

  .flotas-registro-cantidad {
    display: flex;
    justify-content: space-evenly;
    margin: 0 auto;
    width: 60%;
  }

  .flotas-registro-cantidad input.flotas-input {
    width: 40%;
  }

  .flotas-status {
    margin: 0 auto;
  }

  .flotas-image-info {
    width: 70%;
  }

  .flotas-document-btn {
    display: block;
    font-size: 1em;
  }

  label.flotas-document-btn {
    padding-top: 0.8em;
  }

  .no-flota {
    margin-top: -5em;
  }

  .back-btn-tarjeta {
    width: 25%;
  }

  .flotas-model-download {
    flex-direction: column;
    text-align: center;
  }

  .flotas-pdf-icon {
    width: 60px;
    height: 60px;
    padding: 0.8em;
  }

  .flotas-info-tags {
    display: inline-flex !important;
    width: -moz-fit-content;
    width: fit-content;
    overflow: hidden;
  }

  .flotas-info {
    position: absolute;
    top: 0;
    width: -moz-fit-content;
    width: fit-content;
  }

  .flota-bloqueada {
    margin: 0 1em;
  }

  .flota-bloqueada-icon {
    margin-right: 1em;
  }

  .flotas-selection {
    display: inline;
  }

  .flotas-selection .dropdown-toggle::after,
  .flotas-saldo .dropdown-toggle::after {
    position: inherit;
  }

  .flotas-selection .dropdown-toggle,
  .flotas-saldo .dropdown-toggle {
    width: -moz-fit-content;
    width: fit-content;
    text-align: center;
  }

  .flotas-selection > .dropdown-menu {
    text-align: center;
    width: 100%;
    top: -20% !important;
    max-height: 200px;
    overflow-y: auto;
  }

  /* .flotas-info-tags > .alert.alert-danger {
    max-width: 10em;
  } */

  .flotas-info-tag-title {
    display: block;
    font-size: 0.7em !important;
    font-weight: 700 !important;
    margin-bottom: inherit;
  }

  .flotas-info-tag-number {
    font-size: 1em !important;
    font-weight: 900 !important;
  }

  .flotas-info-tipo-cuenta {
    margin-top: inherit;
  }

  table.flotas thead {
    border-bottom: 1px solid #dbdbdb;
  }

  table.flotas tr,
  table.flotas td {
    border-bottom: none;
  }
  table.flotas th,
  table.flotas th:last-child,
  table.flotas td {
    text-align: left;
  }

  table.flotas th,
  table.flotas td {
    display: table-cell !important;
  }

  .no-pointer {
    cursor: not-allowed;
    pointer-events: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/flotas/flotas.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;;EAEE,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;;EAEE,cAAc;EACd,iEAAqE;EACrE,wBAAwB,EAAE,qBAAqB;EAC/C,sBAAsB;AACxB;;AAEA;;EAEE,sBAAsB;EACtB,oEAAyE;EACzE,oBAAoB;EACpB,4BAA4B;EAC5B,2BAA2B;EAC3B,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;EACrC,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,uBAAkB;EAAlB,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;;EAEE,yBAAyB;EACzB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,0BAA0B;EAC1B,WAAW;EACX,gBAAgB;AAClB;;AAEA;;EAEE,sBAAsB;EACtB,oEAA0E;EAC1E,oBAAoB;EACpB,4BAA4B;EAC5B,2BAA2B;EAC3B,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;EACrC,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;EACV,UAAU;AACZ;;AAEA;;EAEE,qBAAqB;EACrB,uCAAuC;AACzC;;AAEA;EACE;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,qBAAqB;EACvB;EACA;IACE,oBAAoB;EACtB;AACF;;AAEA;;EAEE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,sBAAsB;EACtB,yDAA+pF;EAC/pF,sBAAsB;EACtB,4BAA4B;EAC5B,2BAA2B;EAC3B,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;;;EAGE,yBAAyB;EACzB,YAAY;EACZ,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;;;EAKE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gEAAgE;AAClE;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE;qDACmD;AACrD;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,2BAAsB;EAAtB,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,2BAAsB;EAAtB,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,2BAAsB;EAAtB,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,2BAAsB;EAAtB,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,2BAAsB;EAAtB,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,4DAA+L;AACjM;;AAEA;EACE,4DAA8L;AAChM;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,yCAAyC;EACzC,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,6BAA6B;EAC7B,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,kGAAkG;EAClG,4BAA4B;EAC5B,qBAAqB;EACrB,4BAA4B;EAC5B,UAAU;EACV,aAAa;EACb,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,kGAAkG;EAClG,4BAA4B;EAC5B,qBAAqB;EACrB,4BAA4B;EAC5B,UAAU;EACV,aAAa;EACb,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,kGAAkG;EAClG,4BAA4B;EAC5B,qBAAqB;EACrB,4BAA4B;EAC5B,UAAU;EACV,aAAa;EACb,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,kGAAkG;EAClG,4BAA4B;EAC5B,qBAAqB;EACrB,4BAA4B;EAC5B,UAAU;EACV,aAAa;EACb,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,oBAAoB;EACpB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;;;EAGE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;EACzB,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,2BAA2B;EAC3B,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;AACA,6BAA6B;EAC3B,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;AACA;;AAEA,0BAA0B;AAC1B;EACE,mBAAmB;EACnB;IACE,uBAAkB;IAAlB,kBAAkB;IAClB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,6BAA6B;IAC7B,cAAc;IACd,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,cAAc;IACd,cAAc;EAChB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,+BAA+B;IAC/B,uBAAkB;IAAlB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,uBAAkB;IAAlB,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;;IAEE,uBAAkB;IAAlB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,oBAAoB;IACpB,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;;KAEG;;EAEH;IACE,cAAc;IACd,2BAA2B;IAC3B,2BAA2B;IAC3B,sBAAsB;EACxB;;EAEA;IACE,yBAAyB;IACzB,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gCAAgC;EAClC;;EAEA;;IAEE,mBAAmB;EACrB;EACA;;;IAGE,gBAAgB;EAClB;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;AACF","sourcesContent":["table.flotas td {\r\n  font-weight: 700;\r\n  vertical-align: middle;\r\n}\r\n\r\n.flotas-btn button img {\r\n  opacity: 0.7;\r\n  transition: all 0.2s linear;\r\n}\r\n\r\n.flotas-btn button img:hover,\r\n.flotas-btn button img:active {\r\n  opacity: 1;\r\n  transition: all 0.2s linear;\r\n}\r\n\r\n.flotas-table-select {\r\n  display: inline;\r\n  vertical-align: super;\r\n}\r\n\r\n.flotas-table-select > input[type=\"checkbox\"] {\r\n  padding: 0.5em;\r\n  margin: 0em 2em;\r\n  cursor: pointer;\r\n}\r\n\r\n.flotas-table-select > input[type=\"checkbox\"]:checked::after,\r\n.flotas-table-select > .form-check-input:checked[type=\"checkbox\"] {\r\n  color: #db0b27;\r\n  --bs-form-check-bg-image: url(\"../../assets/images/checbox-icon.svg\");\r\n  background-size: 60% 60%; /* Adjust as needed */\r\n  background-color: #fff;\r\n}\r\n\r\n.flotas-table .dropdown-toggle::after,\r\n.flotas-saldo .dropdown-toggle::after {\r\n  content: \"\" !important;\r\n  background-image: url(\"../../assets/images/file-download.svg\") !important;\r\n  background-size: 1em;\r\n  background-repeat: no-repeat;\r\n  background-position: center;\r\n  width: 1.2em;\r\n  height: 1.2em;\r\n  margin-left: 0.5em;\r\n  font-size: 0.8em;\r\n  animation: rotate-up 0.3s ease-in-out;\r\n  transform: scaleY(1);\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n  position: absolute;\r\n  right: 1em;\r\n  top: 2.2em;\r\n}\r\n\r\n.flotas-btn-add {\r\n  font-size: 0.9em;\r\n}\r\n\r\n.flotas-selection {\r\n  display: block;\r\n  width: 100%;\r\n}\r\n\r\n.flotas-selection-div {\r\n  display: inline-block;\r\n  width: fit-content;\r\n  padding: 1.3em 1em;\r\n  border-radius: 0.375rem;\r\n  background-color: #ececec;\r\n  border: none;\r\n  color: #2b363b;\r\n  font-weight: 700;\r\n  margin-right: 0.48em;\r\n  cursor: not-allowed;\r\n  text-transform: capitalize;\r\n}\r\n\r\n.flotas-selection .dropdown-toggle,\r\n.flotas-saldo .dropdown-toggle {\r\n  background-color: #ececec;\r\n  border: none;\r\n  color: #2b363b;\r\n  font-weight: 700;\r\n  padding-bottom: 0.9em;\r\n  padding-top: 0.9em;\r\n  text-transform: capitalize;\r\n  width: 100%;\r\n  text-align: left;\r\n}\r\n\r\n.flotas-selection .dropdown-toggle::after,\r\n.flotas-saldo .dropdown-toggle::after {\r\n  content: \"\" !important;\r\n  background-image: url(\"../../assets/images/user-menu-icon.svg\") !important;\r\n  background-size: 1em;\r\n  background-repeat: no-repeat;\r\n  background-position: center;\r\n  width: 1.2em;\r\n  height: 1.2em;\r\n  margin-left: 0.5em;\r\n  font-size: 0.8em;\r\n  animation: rotate-up 0.3s ease-in-out;\r\n  transform: scaleY(1);\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n  position: absolute;\r\n  right: 1em;\r\n  top: 2.2em;\r\n}\r\n\r\n.flotas-selection .dropdown-toggle.show::after,\r\n.flotas-saldo .dropdown-toggle.show::after {\r\n  transform: scaleY(-1);\r\n  animation: rotate-down 0.3s ease-in-out;\r\n}\r\n\r\n@keyframes rotate-down {\r\n  0% {\r\n    transform: scaleY(1);\r\n  }\r\n  100% {\r\n    transform: scaleY(-1);\r\n  }\r\n}\r\n\r\n@keyframes rotate-up {\r\n  0% {\r\n    transform: scaleY(-1);\r\n  }\r\n  100% {\r\n    transform: scaleY(1);\r\n  }\r\n}\r\n\r\n.flotas-selection .dropdown-toggle::before,\r\n.flotas-saldo .dropdown-toggle::before {\r\n  content: \"\";\r\n  font-size: 1.3em;\r\n  margin-right: 0.2em;\r\n}\r\n\r\n.flotas-selection .dropdown-toggle::before,\r\n.flotas-selection-div::before {\r\n  content: \"\" !important;\r\n  background-image: url(\"data:image/svg+xml;base64,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\");\r\n  background-size: 1.4em;\r\n  background-repeat: no-repeat;\r\n  background-position: center;\r\n  width: 2em;\r\n  height: 2em;\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n}\r\n\r\n.flotas-selection.show > .btn-primary.dropdown-toggle,\r\n.flotas-saldo.show > .btn-primary.dropdown-toggle,\r\n.btn-primary.dropdown-toggle:active:focus {\r\n  background-color: #ececec;\r\n  border: none;\r\n  color: #2b363b;\r\n  box-shadow: none;\r\n}\r\n\r\n.flotas-saldo.show > .btn-primary.dropdown-toggle:focus {\r\n  box-shadow: none;\r\n}\r\n\r\n.flotas-actions {\r\n  margin-top: 0em;\r\n}\r\n\r\n.flotas-actions .dropdown {\r\n  /* margin-right: 0; */\r\n  width: fit-content;\r\n}\r\n\r\n.flotas-selection-item {\r\n  text-transform: capitalize;\r\n}\r\n\r\n.flotas-buttons {\r\n  display: flex;\r\n  flex-direction: row-reverse;\r\n}\r\n\r\n.flotas-buttons .btn-check:checked + .btn-outline-danger {\r\n  background-color: #db0b27;\r\n  border-color: #db0b27;\r\n  transition: all 0.3s 0.1s ease-in-out;\r\n}\r\n\r\n.flotas-btn-km label {\r\n  border-radius: 3em;\r\n  font-size: 0.7em;\r\n  font-weight: 700;\r\n  line-height: 1em;\r\n  max-width: 5em;\r\n}\r\n\r\n.flotas-btn-km.btn-group > .btn:nth-child(n + 3),\r\n.flotas-btn-km.btn-group > :not(.btn-check) + .btn,\r\n.flotas-btn-km.btn-group > .btn-group:not(:first-child) > .btn,\r\n.flotas-btn-km.btn-group > .btn:not(:last-child):not(.dropdown-toggle),\r\n.flotas-btn-km.btn-group > .btn-group:not(:last-child) > .btn {\r\n  border: none;\r\n  border-radius: 3em;\r\n}\r\n\r\n.flotas-btn-km.btn-group {\r\n  background-color: #ececec;\r\n  border-radius: 3em;\r\n  transition: all 0.3s 0.1s ease-in-out;\r\n}\r\n\r\n.btn-check:checked + .btn-outline-danger:focus {\r\n  box-shadow: none;\r\n}\r\n\r\n#notifications-icon-check img.flotas-btn-notification-white {\r\n  filter: invert(42%) saturate(2%) brightness(200%) contrast(200%);\r\n}\r\n\r\n.alert-danger-form {\r\n  color: #db0b27;\r\n  background-color: #f2dede;\r\n  border-color: #ebccd1;\r\n  font-size: 0.9em;\r\n}\r\n\r\n.flotas-btn-error {\r\n  border: #db0b27;\r\n  border-width: 3px;\r\n  border-style: solid;\r\n}\r\n\r\n.filter-primary {\r\n  filter: brightness(0) saturate(100%) invert(13%) sepia(98%) saturate(4979%)\r\n    hue-rotate(346deg) brightness(87%) contrast(100%);\r\n}\r\n\r\n.alert-promocion {\r\n  background-color: #8bf1b6;\r\n  border-color: #8bf1b6;\r\n  min-width: fit-content;\r\n  padding: 1em;\r\n  text-align: center;\r\n  width: 80%;\r\n}\r\n\r\n.alert-incidencia {\r\n  color: #842029;\r\n  background-color: #f8d7da;\r\n  border-color: #f5c2c7;\r\n  min-width: fit-content;\r\n  padding: 1em;\r\n  text-align: center;\r\n  width: 80%;\r\n}\r\n\r\n.alert-repostaje {\r\n  color: #055160;\r\n  background-color: #cff4fc;\r\n  border-color: #b6effb;\r\n  min-width: fit-content;\r\n  padding: 1em;\r\n  text-align: center;\r\n  width: 80%;\r\n}\r\n\r\n.alert-credito {\r\n  color: #084298;\r\n  background-color: #cfe2ff;\r\n  border-color: #b6d4fe;\r\n  min-width: fit-content;\r\n  padding: 1em;\r\n  text-align: center;\r\n  width: 80%;\r\n}\r\n\r\n.alert-antifraude {\r\n  color: #664d03;\r\n  background-color: #fff3cd;\r\n  border-color: #ffecb5;\r\n  min-width: fit-content;\r\n  padding: 1em;\r\n  text-align: center;\r\n  width: 80%;\r\n}\r\n\r\n.flotas-selection > .dropdown-menu {\r\n  background-color: #ececec;\r\n  border: none;\r\n  text-align: left;\r\n  width: 100%;\r\n  top: 90% !important;\r\n}\r\n\r\n.flotas-selection > .dropdown-menu a {\r\n  font-weight: 700;\r\n  padding-bottom: 0.5em;\r\n  padding-top: 0.5em;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.no-flota {\r\n  text-align: center;\r\n}\r\n\r\n.no-flota h2 {\r\n  margin-top: 5vh;\r\n}\r\n\r\n#buscadorFlotas::placeholder {\r\n  color: #2b363b80;\r\n  font-weight: 600;\r\n}\r\n\r\n#switch-km {\r\n  border-radius: 2em;\r\n  font-size: 1em;\r\n}\r\n\r\n#switch-km:hover {\r\n  cursor: pointer;\r\n}\r\n\r\n.form-switch .form-check-input:focus {\r\n  --bs-form-switch-bg: url(\"data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%28218, 13, 41, 0.25%29%27/%3e%3c/svg%3e\");\r\n}\r\n\r\n.form-switch .form-check-input:checked {\r\n  --bs-form-switch-bg: url(\"data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%28255, 255, 255, 1%29%27/%3e%3c/svg%3e\");\r\n}\r\n\r\n.flotas-registro-nueva .btn-flota-registro-tipo.btn-lg {\r\n  background-color: #ececec;\r\n  border: none;\r\n  border-radius: 17px;\r\n  box-shadow: 3px 4px 10px rgb(0 0 0 / 30%);\r\n  color: #2b363b;\r\n  font-size: 1.6em;\r\n  font-weight: 700;\r\n  margin-bottom: 2vh;\r\n  padding: 2.5em 2em;\r\n  width: 100%;\r\n}\r\n\r\nh1.flotas-registro {\r\n  font-size: 1.4em;\r\n  font-weight: 700;\r\n}\r\n\r\nh1.flotas-registro.centered {\r\n  text-align: center;\r\n}\r\n\r\n.btn-primary:disabled,\r\n.btn-primary.disabled {\r\n  background-color: transparent;\r\n  border-color: #2b363b40;\r\n  color: #2b363b40;\r\n}\r\n\r\n.flotas-registro-buttons {\r\n  display: inline-flex;\r\n  justify-content: space-between;\r\n}\r\n\r\n.flotas-registro-buttons button {\r\n  margin: 0 0.3em;\r\n  width: inherit;\r\n}\r\n\r\ninput.flotas-input {\r\n  font-size: 1.7em;\r\n  font-weight: 700;\r\n  min-height: 2em;\r\n  padding: 0;\r\n  text-align: center;\r\n}\r\n\r\ninput.flotas-input:focus {\r\n  background-color: #ececec;\r\n  min-height: 2em;\r\n  padding: 0;\r\n}\r\n\r\np.flotas-registro-moneda {\r\n  font-size: 1.4em;\r\n  margin-top: 1.4em;\r\n  text-align: center;\r\n}\r\n\r\n.flotas-pref-tel > .dropdown-toggle::after {\r\n  content: \"\" !important;\r\n  font-size: 1em;\r\n  transform: rotate(180deg);\r\n}\r\n\r\n.btn-flotas-tel {\r\n  border: 1px solid #ced4da;\r\n  border-radius: 0.25rem;\r\n  line-height: 1.25;\r\n  padding: 1rem 0.75rem;\r\n}\r\n\r\n.flotas-pref-tel.flotas-pref-tel-ES > .dropdown-toggle::before {\r\n  background-image: url(https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/4.1.4/flags/4x3/es.svg);\r\n  background-size: 1.5em 1.5em;\r\n  display: inline-block;\r\n  background-repeat: no-repeat;\r\n  width: 2em;\r\n  height: 1.5em;\r\n  content: \"\";\r\n  vertical-align: bottom;\r\n}\r\n\r\n.flotas-pref-tel.flotas-pref-tel-PT > .dropdown-toggle::before {\r\n  background-image: url(https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/4.1.4/flags/4x3/pt.svg);\r\n  background-size: 1.5em 1.5em;\r\n  display: inline-block;\r\n  background-repeat: no-repeat;\r\n  width: 2em;\r\n  height: 1.5em;\r\n  content: \"\";\r\n  vertical-align: bottom;\r\n}\r\n\r\n.flotas-pref-tel.flotas-pref-tel-AR > .dropdown-toggle::before {\r\n  background-image: url(https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/4.1.4/flags/4x3/ar.svg);\r\n  background-size: 1.5em 1.5em;\r\n  display: inline-block;\r\n  background-repeat: no-repeat;\r\n  width: 2em;\r\n  height: 1.5em;\r\n  content: \"\";\r\n  vertical-align: bottom;\r\n}\r\n\r\n.flotas-pref-tel.flotas-pref-tel-MX > .dropdown-toggle::before {\r\n  background-image: url(https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/4.1.4/flags/4x3/mx.svg);\r\n  background-size: 1.5em 1.5em;\r\n  display: inline-block;\r\n  background-repeat: no-repeat;\r\n  width: 2em;\r\n  height: 1.5em;\r\n  content: \"\";\r\n  vertical-align: bottom;\r\n}\r\n\r\n.flotas-pref-tel > .dropdown-menu.show {\r\n  border: 2px solid #f5c2c7;\r\n  border-radius: 0.8em;\r\n  margin-bottom: 0.7em;\r\n  padding: 1em;\r\n  width: 14em;\r\n}\r\n\r\n.flotas-pref-tel > .dropdown-menu.show > a {\r\n  font-size: 1.1em;\r\n  font-weight: 600;\r\n  padding: 0.4em 1.5em 0.4em 0.3em;\r\n}\r\n\r\n.flotas-pref-tel > .dropdown-menu.show > a > img {\r\n  height: 1.8em !important;\r\n  margin-right: 1em;\r\n  width: 1.8em !important;\r\n}\r\n\r\n.back-btn-tarjeta {\r\n  margin-left: 10%;\r\n  width: 83%;\r\n}\r\n\r\n.flotas-warning-icon,\r\n.flotas-pdf-icon,\r\n.flotas-study-icon {\r\n  border-radius: 10px;\r\n  display: block;\r\n  height: 80px;\r\n  padding: 1.5em 1em;\r\n  text-align: center;\r\n  width: 80px;\r\n}\r\n\r\n.flotas-warning-icon {\r\n  background-color: #ececec;\r\n}\r\n\r\n.flotas-pdf-icon {\r\n  background-color: #db0b27;\r\n}\r\n\r\n.flotas-study-icon {\r\n  padding: 0.5em;\r\n}\r\n\r\n.flotas-model-download {\r\n  align-items: center;\r\n  display: flex;\r\n}\r\n\r\n.flotas-model-download p {\r\n  margin-left: 0.8em;\r\n}\r\n\r\n.flotas-status-process {\r\n  color: #ffc107;\r\n  font-weight: 700;\r\n}\r\n\r\n.flotas-status {\r\n  align-items: center;\r\n  display: flex;\r\n}\r\n\r\n.flotas-status img {\r\n  max-width: 60px;\r\n}\r\n\r\np.flotas-study {\r\n  max-width: 75%;\r\n  text-align: left;\r\n}\r\n\r\n#upload-document {\r\n  opacity: 0;\r\n  position: absolute;\r\n  width: 20%;\r\n  z-index: -1;\r\n}\r\n\r\n.flotas-document-btn {\r\n  display: flex;\r\n  justify-content: space-evenly;\r\n}\r\n\r\n.modal-80w {\r\n  max-width: 80vw;\r\n}\r\n\r\n.row-no-padding {\r\n  padding: 0;\r\n  margin-left: 0;\r\n}\r\n\r\n.flotas-info-tipo-cuenta {\r\n  font-size: 1.2em !important;\r\n  font-weight: 900 !important;\r\n  display: block;\r\n  text-transform: capitalize;\r\n}\r\n\r\n.flotas-info-tags {\r\n  display: flex;\r\n  overflow-x: scroll;\r\n  width: max-content;\r\n}\r\n\r\n.flotas-info-tags > .alert.alert-danger {\r\n  text-align: left;\r\n  max-width: 15em;\r\n  min-width: 8.2em;\r\n  padding: 0.3em 2em 0.3em 1em;\r\n  background-color: #ececec;\r\n  border: none;\r\n  color: #2b363b;\r\n  margin-right: 0.6em;\r\n  max-height: 4.1em;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.flotas-info-tag-title {\r\n  display: block;\r\n  font-size: 1em !important;\r\n  font-weight: 700 !important;\r\n  margin-bottom: -0.5em;\r\n  color: #2b363bbf;\r\n}\r\n\r\n.flotas-info-tag-number {\r\n  font-size: 1.3em !important;\r\n  font-weight: 900 !important;\r\n}\r\n\r\n.flota-bloqueada {\r\n  max-width: 35em;\r\n  text-align: left;\r\n  display: inline-flex;\r\n  vertical-align: middle;\r\n  font-weight: 700;\r\n  font-size: 0.8em;\r\n  background: #da0d2926;\r\n  padding: 0.6em 1em;\r\n  border-radius: 0.5em;\r\n  color: #da0d29;\r\n  margin-top: 1em;\r\n}\r\n\r\n.flota-bloqueada-icon {\r\n  margin-right: 2em;\r\n  width: 30px;\r\n  height: 31px;\r\n}\r\n\r\n.thin {\r\n  font-weight: 300 !important;\r\n}\r\n\r\n.btn-icon-font {\r\n  color: #606676;\r\n}\r\n\r\n.btn-icon-font:hover {\r\n  color: #1d253c;\r\n}\r\n\r\n.flotas-actions-btn-trash {\r\n  font-size: 0.9em;\r\n}\r\n\r\n.btn-outline-grey .flotas-actions-btn-trash{\r\nbackground-color: transparent;\r\n  border-color: #2b363b40;\r\n  color: #2b363b40;\r\n}\r\n\r\n/* BREAKPOINT TABLETS*/\r\n@media (min-width: 768px) {\r\n}\r\n\r\n/* BREAKPOINT ESCRITORIO */\r\n@media (min-width: 992px) {\r\n  /* General Styles */\r\n  .flotas-register-btn {\r\n    width: fit-content;\r\n    margin: 0 auto;\r\n    padding-left: 2em;\r\n    padding-right: 2em;\r\n  }\r\n\r\n  .flotas-btn-step1 {\r\n    display: flex;\r\n  }\r\n\r\n  .flotas-registro-nueva .btn-flota-registro-tipo.btn-lg {\r\n    margin: 0 0.5em;\r\n  }\r\n\r\n  .flotas-registro-cantidad {\r\n    display: flex;\r\n    justify-content: space-evenly;\r\n    margin: 0 auto;\r\n    width: 60%;\r\n  }\r\n\r\n  .flotas-registro-cantidad input.flotas-input {\r\n    width: 40%;\r\n  }\r\n\r\n  .flotas-status {\r\n    margin: 0 auto;\r\n  }\r\n\r\n  .flotas-image-info {\r\n    width: 70%;\r\n  }\r\n\r\n  .flotas-document-btn {\r\n    display: block;\r\n    font-size: 1em;\r\n  }\r\n\r\n  label.flotas-document-btn {\r\n    padding-top: 0.8em;\r\n  }\r\n\r\n  .no-flota {\r\n    margin-top: -5em;\r\n  }\r\n\r\n  .back-btn-tarjeta {\r\n    width: 25%;\r\n  }\r\n\r\n  .flotas-model-download {\r\n    flex-direction: column;\r\n    text-align: center;\r\n  }\r\n\r\n  .flotas-pdf-icon {\r\n    width: 60px;\r\n    height: 60px;\r\n    padding: 0.8em;\r\n  }\r\n\r\n  .flotas-info-tags {\r\n    display: inline-flex !important;\r\n    width: fit-content;\r\n    overflow: hidden;\r\n  }\r\n\r\n  .flotas-info {\r\n    position: absolute;\r\n    top: 0;\r\n    width: fit-content;\r\n  }\r\n\r\n  .flota-bloqueada {\r\n    margin: 0 1em;\r\n  }\r\n\r\n  .flota-bloqueada-icon {\r\n    margin-right: 1em;\r\n  }\r\n\r\n  .flotas-selection {\r\n    display: inline;\r\n  }\r\n\r\n  .flotas-selection .dropdown-toggle::after,\r\n  .flotas-saldo .dropdown-toggle::after {\r\n    position: inherit;\r\n  }\r\n\r\n  .flotas-selection .dropdown-toggle,\r\n  .flotas-saldo .dropdown-toggle {\r\n    width: fit-content;\r\n    text-align: center;\r\n  }\r\n\r\n  .flotas-selection > .dropdown-menu {\r\n    text-align: center;\r\n    width: 100%;\r\n    top: -20% !important;\r\n    max-height: 200px;\r\n    overflow-y: auto;\r\n  }\r\n\r\n  /* .flotas-info-tags > .alert.alert-danger {\r\n    max-width: 10em;\r\n  } */\r\n\r\n  .flotas-info-tag-title {\r\n    display: block;\r\n    font-size: 0.7em !important;\r\n    font-weight: 700 !important;\r\n    margin-bottom: inherit;\r\n  }\r\n\r\n  .flotas-info-tag-number {\r\n    font-size: 1em !important;\r\n    font-weight: 900 !important;\r\n  }\r\n\r\n  .flotas-info-tipo-cuenta {\r\n    margin-top: inherit;\r\n  }\r\n\r\n  table.flotas thead {\r\n    border-bottom: 1px solid #dbdbdb;\r\n  }\r\n\r\n  table.flotas tr,\r\n  table.flotas td {\r\n    border-bottom: none;\r\n  }\r\n  table.flotas th,\r\n  table.flotas th:last-child,\r\n  table.flotas td {\r\n    text-align: left;\r\n  }\r\n\r\n  table.flotas th,\r\n  table.flotas td {\r\n    display: table-cell !important;\r\n  }\r\n\r\n  .no-pointer {\r\n    cursor: not-allowed;\r\n    pointer-events: none;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
